import { observable, action } from 'mobx'
import { message } from 'hljd'
import BaseStore from '@store/table'
import Api from '@api/sa_li/billing'
import { getMomentTime } from '@hlj/hlj-utils'

class Store extends BaseStore {
  $ignoreParams = ['created_at']
  $listApi = Api.invoiceList

  $getParams = () => {
    const { created_at } = this.$params

    return {
      // eslint-disable-next-line no-undef
      start_time: getMomentTime(created_at, 0),
      // eslint-disable-next-line no-undef
      end_time: getMomentTime(created_at, 1),
      ...this.$params
    }
  }

  @observable saveLoading = false
  @observable modalLoading = false
  @observable record = {}
  // 详情
  @observable detailModalVisible = false

  @action
  openDetailModal = async (id, from_pixiu) => {
    this.modalLoading = true
    this.detailModalVisible = true

    const { data } = await Api.invoiceDetail({
      [from_pixiu === 1 ? 'pixiu_order_id' : 'order_id']: id
    })
    this.record = data
    this.modalLoading = false
  }

  @action
  closeDetailModal = () => {
    this.detailModalVisible = false
  }

  @observable applyRecord = {}
  @observable company_type = '1'
  @observable invoice_type = '1'

  // 申请开票
  @observable applyModalVisible = false
  @observable applyImages = []

  @action
  openApplyModal = async record => {
    this.modalLoading = true
    this.record = record

    const { data } = await Api.preSaveInvoice()

    if (Array.isArray(data) && data.length === 0) {
      this.applyRecord = {}
    } else {
      this.applyRecord = data || {}
    }

    const { images } = this.applyRecord
    this.applyImages =
      images === 'null' || !images ? JSON.parse('[]') : JSON.parse(images)
    this.company_type = data.kind || '1'
    this.invoice_type = data.invoice_kind || '1'
    this.applyModalVisible = true
    this.modalLoading = false
  }

  changeInvoiceType = value => {
    this.invoice_type = value
  }

  changeCompanyType = value => {
    this.company_type = value
  }

  @action
  closeApplyModal = () => {
    this.applyModalVisible = false
  }

  saveInvoice = async params => {
    this.saveLoading = true
    const { success } = await Api.invoiceSave(params)
    this.saveLoading = false
    if (success) {
      message.success('提交成功')
      this.applyModalVisible = false
      this.$getList()
    } else {
      this.applyModalVisible = false
    }
  }
}

export default new Store()
